import type { BoardStatus } from '../types/stripboard'

export const createStripboardRecordDefaults = (input: {
  boardStatus?: BoardStatus | null
  startDate?: string | null
  endDate?: string | null
  priority?: number
} = {}) => ({
  boardStatus: input.boardStatus ?? null,
  priority: Math.max(1, Math.min(5, Math.round(input.priority ?? 1))),
  startDate: input.startDate ?? null,
  endDate: input.endDate ?? null,
  dependencyNodeIds: [] as string[],
  invalidDependencyNodeIds: [] as string[],
  recordVersion: 1,
  statusSyncOrigin: 'CREATE',
  statusSyncVersion: 1,
})
